// TODO: to be deprecated
export const i18nAlarmPage = {
  sections: {
    prediction_graph: 'Modelo de risco de falha',
    pump_curve: 'Curva de performance da bomba',
    sensors_graph: 'Dados dos sensores',
    analysis: 'Análise',
    history: 'Histórico',
    alarms_list: 'Últimos alarmes {{asset}}',
    flat_line_graph: 'Flat line',
    diagnostic: 'Diagnóstico',
    recommendation: 'Recomendações',
  },
  components: {
    alarm_summary: {
      start_time: 'Início',
      end_time: 'Término',
      asset_name: 'Equipamento',
      description: 'Descrição do alarme',
      status: 'Status',
      classification: 'Classificação',
      model: 'Modelo',
      id: 'ID do alarme',
    },
    analysis: {
      fields: {
        status: 'Status',
        classification: 'Classificação',
        action: 'Ação do operador',
        work_order: 'Ordem de serviço (número)',
        reason: 'Motivo',
        failure_occurred: 'Houve falha?',
        additional_info: 'Informações adicionais',
        end_date: 'Estimativa para concluir investigação',
      },
      actions: {
        attach: 'Anexar arquivo',
        save: 'Salvar',
        attachments: 'Anexos',
        required_field: 'Campo obrigatório',
        max_length: 'Tamanho máximo de {{size}} caracteres',
      },
    },
    suspension: {
      suspend_new_alarms: 'Suspenda novos alarmes por um período',
      this_model_no_alarms: 'Este modelo não gerará novos alarmes até a data abaixo.',
      select_date: 'Selecione a data',
    },
    history: {
      comment_placeholder: 'Adicione um comentário',
      empty_history: 'Alarme sem histórico de alterações',
      action_title: {
        attach_file: 'Arquivo anexado',
        remove_file: 'Arquivo removido',
        status_change: '{{userName}} alterou status do alarme',
        change_end_date: '{{userName}} alterou data de término',
        add_work_order: '{{userName}} adicionou Work Order Number',
        add_details: '{{userName}} inseriu um diagnóstico',
      },
      action: {
        attach_file: '{{userName}} anexou {{filename}}',
        remove_file: '{{userName}} removeu {{filename}}',
        status_change: '{{userName}} alterou status de {{previousStatus}} para {{currentStatus}}',
        change_end_date: '{{userName}} alterou a data de término para {{endDate}}',
        add_work_order: '{{userName}} adicionou o Work Order Number: {{workOrder}}',
        add_details: '{{userName}} inseriu um diagnóstico: {{details}}',
      },
    },
    sensors_graph: {
      variables_contribution: 'Contribuição por variáveis',
    },
  },
  message: {
    generic_error: {
      title: 'Ops..',
      message: 'Ocorreu um erro inesperado. Aguarde alguns minutos e tente novamente',
    },
    inexistent_alarm: {
      title: 'Alarme não encontrado',
      message: 'Por favor, tente com um id de alarme válido',
    },
    features_contribution_error: {
      title: 'Ops..',
      message: 'Erro ao carregar dados de contribuição por feature',
    },
    analysis_submit: {
      success: { title: 'Sucesso', message: 'Análise enviada' },
      error: { title: 'Erro', message: 'Falha ao enviar análise' },
    },
  },
};
